// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cl-j";
export var fulfillmentFormRail = "_cl-i";
export var headerTitleRow = "_cl-l";
export var orderDetailsWrapper = "_cl-g";
export var orderLinkTrigger = "_cl-2";
export var paymentInformationGrid = "_cl-q";
export var paymentSummaryColumn = "_cl-r";
export var phoneShipmentPickerButton = "_cl-e";
export var phoneShipmentPickerButtonContent = "_cl-f";
export var phoneShipmentPickerButtonWrapper = "_cl-d";
export var phoneShipmentPickerTrigger = "_cl-c";
export var shipmentContainer = "_cl-k";
export var shipmentDetailsMainPane = "_cl-h";
export var shipmentNavigationCard = "_cl-a";
export var shipmentNavigationEdgeTrigger = "_cl-6";
export var shipmentNavigationRail = "_cl-3";
export var shipmentNavigationRailEnter = "_cl-5";
export var shipmentNavigationRailHeader = "_cl-9";
export var shipmentNavigationRailOverlay = "_cl-4";
export var shipmentNavigationScrim = "_cl-7";
export var shipmentSummaryFact = "_cl-n";
export var shipmentSummaryGrid = "_cl-m";
export var shipmentSummaryMetadataRow = "_cl-o";
export var shipmentSummaryTags = "_cl-p";
export var shipmentWorkspace = "_cl-0";
export var shipmentWorkspaceBodyTablet = "_cl-8";
export var shipmentWorkspaceContent = "_cl-b";
export var shipmentWorkspaceHeader = "_cl-1";